import template from './add_objective_plan.html';
import * as Utils from '../../lib/savanna_utils.js';

class AddObjectivePlanViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.title = ko.observable();
		this.objective_plan_id = ko.observable();
		//this.date = ko.observable(moment().format('YYYY-MM-DD'));
		this.employment_info = ko.observable();
		this.due_date = ko.observable();
		this.today = ko.observable(new Date().toISOString().split('T')[0]);
		this.objective_plan = ko.observable();
		this.objective_name = ko.observable();
		this.description = ko.observable();
		this.setup_date = ko.observable();
		this.selected_performance_cycle = ko.observable();
		this.cycle_dates = ko.observable();
		this.current_step = ko.observable();
		this.current_step_sequence = ko.observable();
		this.current_step_status = ko.observable();
		this.performance_cycles = ko.observableArray();
		this.selected_rating_system = ko.observable();
		this.rating_systems = ko.observableArray();
		this.step_status_options = ko.observableArray();
		this.cycle_steps_options = ko.observableArray();
		this.edit = ko.observable(false);
		this.rating_types = ko.observableArray(['single-select', 'multiselect', 'range', 'input', 'number' ]);
		this.selected_rating_type = ko.observable();
		this.cycle_changed = ko.observable(false);
		this.status = ko.observable('Not Started');
		this.total_steps = ko.observable(0);

		this.selected_rating_type.subscribe((val) => {
			this.dialog.updateData();
		});

		this.current_step_sequence.subscribe((val) => {
			this.update_status();
		});

		this.rating_placeholder = ko.computed(() => {
			if (!this.rating_systems().length > 0)
				return 'None available';
		});

		this.cycle_placeholder = ko.computed(() => {
			if (!this.performance_cycles().length > 0)
				return 'None available';
		});

		this.selected_performance_cycle.subscribe((val) => {
			if (this.selected_performance_cycle())
				this.dialog.get_cycle_dates(val);
		})
	};

	close()
	{
		this.dialog.close(this.current_step_sequence());
	}

	update_status()
	{
		if (!this.current_step_sequence() || !this.total_steps())
		{
			this.status('Not Started');
			return;
		}

		if (this.current_step_sequence() === 1)
			this.status('In Progress');
		else if (this.current_step_sequence() > 1 && this.current_step_sequence() <= this.total_steps()) 
			this.status('In Progress');
		else 
			this.status('Completed');
	}

	async btn_save()
	{
		if (!this.objective_name())
		{
			Grape.alerts.alert({type: 'warning', message: 'Objective Plan name cannot be empty!'});
			return;
		}
		else
		{
			let res = await Grape.fetches.postJSON('/performance_management/objective_plan/edit', {
				objective_plan_id: this.objective_plan_id() || null,
				name: this.objective_name(),
				employee_id: this.employment_info().employee_id,
				cycle_id: this.selected_performance_cycle(),
				due_date: this.due_date(),
				setup_date: this.setup_date(),
				status: this.status(),
				current_step: this.current_step_sequence(),
				rating_system_id: this.selected_rating_system(),
				description: this.description()
			});

			if (res.status != 'ERROR')
			{
				Grape.alerts.alert({type: 'success', title: 'Success', message: 'Successfully saved Objective Plan'});
				this.dialog.close(this.current_step_sequence());
			}
			else 
				Grape.alerts.alert({type: 'error', message: 'An error occurred while saving the Objective Plan'});
		}
	}

	async btn_delete_plan()
	{
		let response = await Grape.alerts.confirm({type: 'warning', message: `Are you sure you want to delete ${this.objective_name()}?`});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/performance_management/objective_plan/remove', {objective_plan_id: this.objective_plan_id()});
			if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: 'Successfully deleted'});
				this.dialog.close(true);
			}
			else
				Grape.alerts.alert({type: 'error', message: 'An error occurred while deleting the Objective Plan'});
		}
	}

	async btn_mark_stage_done()
	{
		let response = await Grape.alerts.confirm({ type: 'info', message: `Mark "${this.current_step()}" as done?` });
		if (response)
		{
			let res = await Grape.fetches.postJSON('/performance_management/objective_plan/edit', {
				objective_plan_id: this.objective_plan_id(),
				current_step: this.current_step_sequence() + 1
			});
			if (res.status == 'ERROR') 
				Grape.alerts.apiError(res);
			
			else if (res.status == 'OK')
			{
				let is_completed = await this.dialog.update_current_step();
				// Only show the success alert if the plan isn't completed
				if (!is_completed) 
					Grape.alerts.alert({ type: 'success', title: 'Success', message: 'Stage/step successfully updated' });
			}
			else 
				Grape.alerts.alert({ type: 'error', title: 'Error', message: 'An error occurred while updating current stage/step' });
		}
	}
};

class AddObjectivePlanPage
{
	constructor (bindings)
	{
		this.viewModel = new AddObjectivePlanViewModel(this);
		this.bindings = bindings;
	};

	async init()
	{
		Utils.refresh_data_visible_roles();
		await this.updateData();

		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_performance_cycles',
				schema: 'perfm_manage',
				filter: [{}]
			})
			if (res.status != 'ERROR')
				this.viewModel.performance_cycles(res.records);
		} catch (error) {
			console.error(error)
			Grape.alerts.alert({type: 'error', title: 'Error', message : 'An error occurred when loading the Rating Systems'});
		}

		if (this.bindings)
		{
			this.viewModel.edit(this.bindings.edit);
			this.viewModel.employment_info(ko.mapping.toJS(this.bindings.employee_info));
			this.viewModel.objective_plan(this.bindings.data);
		}

		if (this.viewModel.edit())
		{
			this.viewModel.cycle_changed(false);
			this.viewModel.setup_date(this.bindings.data.setup_date);
			this.viewModel.title('Edit Objective Plan');
			this.viewModel.selected_rating_system(this.bindings.data.rating_system_id);
			this.viewModel.objective_name(this.bindings.data.name);
			this.viewModel.description(this.bindings.data.description);
			this.viewModel.due_date(this.bindings.data.due_date);
			this.viewModel.objective_plan_id(this.bindings.data.objective_plan_id);
			this.viewModel.selected_performance_cycle(this.bindings.data.performance_cycle_id);
			//this.viewModel.current_step(this.bindings.data.current_step_name);
			//this.viewModel.current_step_sequence(this.bindings.data.current_step);
			this.update_current_step();
		}
		else
		{
			this.viewModel.title('Add Objective Plan');
			this.viewModel.cycle_changed(true);
			this.viewModel.setup_date(new Date().toISOString().split('T')[0]);
		}
	}

	async update_current_step()
	{
		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_objective_plans',
				schema: 'perfm_manage',
				fields: ['current_step', 'current_step_name'],
				filter: [
					{
						field: 'objective_plan_id',
						operand: '=',
						value: this.viewModel.objective_plan_id()
					}
				]
			});

			if (res.records[0].current_step_name == null)
			{
				Grape.alerts.alert({ type: 'success', title: 'Objective Plan Completed', message: 'The Objective Plan is now completed.' });
				this.viewModel.close();
				return true; // Indicate that the plan is completed
			}

			if (res.status != 'ERROR')
			{
				this.viewModel.current_step(res.records[0].current_step_name);
				this.viewModel.current_step_sequence(res.records[0].current_step);
			}
			return false; // Indicate that the plan is not completed
		} catch (error)
		{
			console.error(error);
			Grape.alerts.alert({ type: 'error', title: 'Error', message: 'An error occurred when loading the steps for the selected Performance Cycle' });
			return false;
		}
	}

	async updateData()
	{
		let options = {
			table: 'v_rating_methods',
			schema: 'perfm_manage',
			filter_join: 'AND',
			filter: [{
				field: 'active',
				operand: '=',
				value: true
			}]
		}
		if (this.viewModel.selected_rating_type())
		{
			options.filter.push({
				field: 'rating_method_type',
				operand: '=',
				value: this.viewModel.selected_rating_type()
			});
		}

		try {
			// API to get the available rating systems to choose from
			let res = await Grape.fetches.getJSON('/api/record', options);

			if (res.status != 'ERROR')
				this.viewModel.rating_systems(res.records);

		} catch (error) {
			console.error(error)
			Grape.alerts.alert({type: 'error', title: 'Error', message : 'An error occurred when loading the Rating Systems'});
		}
	}

	async get_cycle_dates(id)
	{
		let selected_cycle = this.viewModel.performance_cycles().find(cycle => cycle.performance_cycle_id === id);
		if (selected_cycle)
			this.viewModel.cycle_dates(selected_cycle.from_date + ' until ' + selected_cycle.to_date);

		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_cycle_stages',
				schema: 'perfm_manage',
				filter_join: 'AND',
				filter: [{
					field: 'performance_cycle_id',
					operand: '=',
					value: id
				}]
			});

			if (res.status !== 'ERROR')
			{
				if (res.records.length > 0)
				{
					let steps = res.records.sort((a, b) => a.step_sequence - b.step_sequence);
					this.viewModel.current_step(steps[0].name);
					this.viewModel.current_step_sequence(steps[0].step_sequence);
					this.viewModel.total_steps(steps.length);
					this.viewModel.update_status();
				}
				else
					this.viewModel.current_step(null);
			}
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', message: 'An error occurred while loading the performance cycle stages.'});
		}
	}
};

export default {
	name: 'AddObjectivePlan',
	dialog_class: AddObjectivePlanPage,
	template: template,
	template_filename: 'translation/dialogs/add_objective_plan',
	provider: 'ps'
};
